module.exports = __webpack_public_path__ + "img/logo-axp.e3fbf5d2.png";